import { resolveAssetUrl } from './api';

export const BRAND_LOGO = resolveAssetUrl('/brand/El_cachuchon_font.png');

export const BRAND_MASCOT = resolveAssetUrl(
  '/brand/El%20Cachuchon%C2%AEKid_Brand_mascot.png'
);
